<template>
  <div class="content">
    <div class="page-list">
      <a-spin
        v-show="pages2.length == 0"
        style="
          width: 100%;
          height: 200px;
          line-height: 200px;
          text-align: center;
        "
      ></a-spin>
      <div
        @click="changeGrowPage(index)"
        v-for="(pageitem, index) in pages2"
        :key="pageitem.c_id"
        class="cell"
      >
        <div
          class="dragbox"
          :style="{ height: (750 * 120) / wrapperWidth + 'px' }"
        >
          <div
            class="wrapper"
            :style="{
              transform: `scale(${(750 * 120) / wrapperWidth / 750})`,
            }"
          >
            <div
              class="wrap2"
              :style="{
                width: wrapperWidth + 'px',
                height: 750 + 'px',
                backgroundImage: 'url(' + pageitem.img_bg + ')',
                backgroundSize: '100% 100%',
                backgroundColor: '#cccccc',
              }"
            >
              <vue-draggable-resizable
                v-for="(item, index2) in pageitem.content"
                :key="item.ec_id"
                :w="item.width"
                :h="item.height"
                :enableNativeDrag="true"
                :x="item.left"
                :y="item.top"
                :r="item.rotate"
                :z="item.zIndex"
                :levelType="item.levelType"
                :frameId="'item' + index + index2"
                :photoScale="item.photoScale"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :showPhoto="item.showPhoto"
                :shadow="item.shadow ? true : false"
                :dIndex="index"
                :debug="false"
                :disable="true"
                :textDecoration="item.textDecoration"
                :textIndent="item.textIndent"
                :writingMode="item.writeMode"
                :lineHeight="item.lineHeight"
                :fontWeight="item.fontWeight"
                :fontStyle="item.fontStyle"
                :textAlign="item.textAlign"
                :type="item.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''"
                :bImg2="item.backImg2"
                :bRadius="item.borderRadius"
                :fontColor="item.fColor"
                :text="item.textarea"
                :o="item.opacity"
                :l="item.lock ? true : false"
                dragHandle="false"
                :backColor="item.bColor"
                :borderColor="item.bordersColor"
                :borderLeft="item.bLeft"
                :borderTop="item.bTop"
                :borderRight="item.bRight"
                :borderBottom="item.bBottom"
                :borderStyle="item.bStyle"
                :listen="false"
                :paddingLeft="item.paddingLeft"
                :paddingTop="item.paddingTop"
                :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom"
                :active="false"
                :fontSize="item.fSize"
              >
                <div v-if="item.type == 3" class="look" style="z-index: -1">
                  <div
                    class="wrap"
                    :style="{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      transform: `scale(${item.width / item.orignWidth},${
                        item.height / item.orignHeight
                      })`,
                      transformOrigin: '0px 0px',
                    }"
                  >
                    <vue-draggable-resizable
                      v-for="(item2, index2) in item.coms"
                      :key="index2"
                      :w="item2.width"
                      :h="item2.height"
                      :x="item2.left"
                      :y="item2.top"
                      :r="item2.rotate"
                      :z="item2.zIndex"
                      :showPhoto="item2.showPhoto"
                      :shadow="item2.shadow ? true : false"
                      :dIndex="index"
                      :debug="false"
                      :disable="true"
                      :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight"
                      :fontStyle="item2.fontStyle"
                      :textAlign="item2.textAlign"
                      :type="item2.type"
                      :isConflictCheck="false"
                      :snap="true"
                      :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                      :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius"
                      :fontColor="item2.fColor"
                      :text="item2.textarea"
                      :o="item2.opacity"
                      :l="item2.lock ? true : false"
                      dragHandle="false"
                      :backColor="item2.bColor"
                      :borderColor="item2.bordersColor"
                      :borderLeft="item2.bLeft"
                      :borderTop="item2.bTop"
                      :borderRight="item2.bRight"
                      :borderBottom="item2.bBottom"
                      :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft"
                      :paddingTop="item2.paddingTop"
                      :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom"
                      :active="false"
                      :fontSize="item2.fSize"
                    ></vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable>
            </div>
          </div>
        </div>
        <div class="name">
          {{
            pageitem.type == 1
              ? "封面"
              : pageitem.type == 3
              ? "封底"
              : pageitem.page_num
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pages2: [],
      s_id: "",
      guc_id: "",
      page: 0,
      wrapperWidth: 600,
    };
  },
  components: {
    VueDraggableResizable,
  },
  created() {
    this.s_id = this.$route.params.s_id;
    this.guc_id = this.$route.params.guc_id;
    this.page = this.$route.query.page ? this.$route.query.page : 0;
    this.getGrowupPageDetail();
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  methods: {
    getGrowupPageDetail() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            var cover_size = res.data.data.info.size.cover_size.split("*");
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            var screenWidth = document.body.clientWidth;
            this.getGrowPages();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res);
        });
    },
    changeGrowPage(index) {
      console.log("emit");
      // if (
      //     pages2[this.page].is_lock &&
      //     pages2[this.page].lock_info.teacher_name !=
      //     this.userInfo.teacher_name
      // ) {
      //     this.$message.error("此页面已经被占用");
      //     setTimeout(() => {
      //         this.$router.back();
      //     }, 1000);
      // }
      this.$emit("emitChangeGrowPage", index);
    },
    getGrowPages() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growPages,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            var pages2 = res.data.data;

            pages2.forEach((page, index) => {
              page.img_bg =
                page.img_bg +
                "?x-image-process=image/resize,w_100/quality,Q_40";
              page.content = page.content.map((arr) => {
                console.log(arr);
                arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                  ? this.clearUrl(arr.backgroundImg) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                arr.backImg2 = this.clearUrl(arr.backImg2)
                  ? this.clearUrl(arr.backImg2) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                arr.showPhoto = this.clearUrl(arr.showPhoto)
                  ? this.clearUrl(arr.showPhoto) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                if (arr.textarea) {
                  arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
                }
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                  if (arr.coms[0] && arr.coms[0].width >= 0) {
                  } else {
                    arr.coms = [];
                  }
                }
                return arr;
              });
            });
            this.pages2 = pages2;
            this.kongwei = true;
            this.$forceUpdate();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.data.msg);
        });
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
.page-list {
  width: 100%;
  overflow: hidden;

  .cell {
    float: left;
    width: 33.33%;
    margin: 10px 0;
    position: relative;
    overflow: hidden;

    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: "";
    }

    .dragbox {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .cover {
      width: 120px;
      height: 170px;
      background: #eee;
      margin-bottom: 15px;
      background-size: contain;
    }

    .name {
      color: #666666;
      font-size: 14px;
      text-align: center;
      height: 20px;
      margin-top: 10px;
      line-height: 20px;
      z-index: 100;
    }
  }
}
</style>